import { Link, useParams } from 'react-router-dom';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { useActividad } from '../../lib/queries/actividades.js';

export function ActividadesView() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useActividad(id);

  if (isLoading) return <div className="text-center py-8 text-gray-600">Cargando…</div>;
  if (error)
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-md text-red-700" role="alert">
        Error: {error.message}
      </div>
    );
  if (!data) return null;

  const { actividad, servicio, reclutamiento, internacional } = data.data;

  return (
    <div className="space-y-4 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-900">{actividad.nombre}</h1>
        <Link to={`/actividades/${id}/edit`}>
          <Button variant="primary">Editar</Button>
        </Link>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Datos generales</CardTitle>
        </CardHeader>
        <CardBody>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <Field label="Tipo" value={actividad.tipo} />
            <Field label="Rama" value={actividad.rama} />
            <Field label="Fecha actividad" value={actividad.fecha_actividad} />
            <Field label="Fecha registro" value={actividad.fecha_registro} />
            <Field label="Lugar" value={actividad.lugar} />
            <Field label="Quarter" value={actividad.quarter} />
            <Field label="Participantes" value={String(actividad.participantes)} />
            <Field label="Beneficiarios" value={String(actividad.beneficiarios ?? '—')} />
            <Field label="Horas" value={String(actividad.horas)} />
          </dl>
        </CardBody>
      </Card>

      {servicio && (
        <Card>
          <CardHeader>
            <CardTitle>Sub-objeto: servicio</CardTitle>
          </CardHeader>
          <CardBody>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <Field label="Tipo servicio" value={servicio.tipo_servicio} />
              <Field label="Comunidad beneficiada" value={servicio.comunidad_beneficiada ?? '—'} />
              <Field label="Descripción" value={servicio.descripcion_servicio} fullWidth />
              <Field label="Aliados" value={servicio.aliados?.join(', ') ?? '—'} fullWidth />
            </dl>
          </CardBody>
        </Card>
      )}

      {reclutamiento && (
        <Card>
          <CardHeader>
            <CardTitle>Sub-objeto: reclutamiento</CardTitle>
          </CardHeader>
          <CardBody>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <Field label="Lugar" value={reclutamiento.lugar_reclutamiento} />
              <Field
                label="Material distribuido"
                value={reclutamiento.material_distribuido ?? '—'}
              />
              <Field label="Contactados" value={String(reclutamiento.prospectos_contactados)} />
              <Field label="Interesados" value={String(reclutamiento.prospectos_interesados)} />
              <Field label="Inscritos" value={String(reclutamiento.prospectos_inscritos)} />
            </dl>
          </CardBody>
        </Card>
      )}

      {internacional && (
        <Card>
          <CardHeader>
            <CardTitle>Sub-objeto: evento internacional</CardTitle>
          </CardHeader>
          <CardBody>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <Field label="País destino" value={internacional.pais_destino} />
              <Field label="Ciudad destino" value={internacional.ciudad_destino ?? '—'} />
              <Field
                label="Organización anfitriona"
                value={internacional.organizacion_anfitriona ?? '—'}
              />
              <Field label="Tipo evento" value={internacional.tipo_evento_internacional} />
              <Field
                label="Participantes internacionales"
                value={String(internacional.participantes_internacionales)}
              />
            </dl>
          </CardBody>
        </Card>
      )}

      <Link to="/actividades">
        <Button variant="ghost">← Regresar al listado</Button>
      </Link>
    </div>
  );
}

function Field({
  label,
  value,
  fullWidth,
}: {
  label: string;
  value: string;
  fullWidth?: boolean;
}) {
  return (
    <div className={fullWidth ? 'sm:col-span-2' : ''}>
      <dt className="text-xs uppercase tracking-wide text-gray-500">{label}</dt>
      <dd className="text-gray-900">{value}</dd>
    </div>
  );
}
